import { NameAttributes } from '@/entities/api/products/product'

export const attributeNameConvert = (name: NameAttributes) => {
	switch (name) {
		case NameAttributes.COLOR:
			return 'Color'
		case NameAttributes.FLAVOR:
            return 'Sabor'
        case NameAttributes.MODALITY:
            return 'Modalidad'
        case NameAttributes.OBJECTIVE:
            return 'Objectivo'
        case NameAttributes.SIZE:
            return 'Talla'
	}
}

